import React from "react";
import { PiMicrophoneFill } from "react-icons/pi";
import { ReactSVG } from "react-svg";
import translationIcon from "../../../Asset/Real-Time Translation.svg";
import usagePreferenceIcon from "../../../Asset/Usage Preference.svg";

const UsagePreferenceCard = ({ type, onTypeChange, disabled = false, className = "" }) => {
  return (
    <div className={`rounded-2xl border border-[#D6ECFB] bg-white p-4 ${className}`}>
      <div className="shrink-0 flex items-center gap-3 md:text-[1.75rem] text-xl font-semibold font-inter">
        <span className="bg-gradient-to-b from-[#3AB1F6] to-[#407BFF] text-white p-1.5 rounded-lg">
          <ReactSVG
            src={usagePreferenceIcon}
            beforeInjection={(svg) => svg.setAttribute("class", "md:w-5 w-4 md:h-5 h-4")}
            className="w-auto"
          />
        </span>
        Usage Preference
      </div>

      <div className="mt-3 flex flex-row gap-2">
        <button
          onClick={() => !disabled && onTypeChange("transcription")}
          disabled={disabled}
          className={`w-1/2 py-3 px-4 rounded-xl flex items-center justify-center lg:justify-start gap-2 text-sm font-inter font-medium transition ${
            disabled ? "opacity-50 cursor-not-allowed" : ""
          } ${
            type === "transcription"
              ? "bg-gradient-to-r from-[#3AB1F6] to-[#407BFF] text-white"
              : "bg-[#EDF5FB] text-[#111827]"
          }`}
        >
          <PiMicrophoneFill />
          Transcription
        </button>

        <button
          onClick={() => !disabled && onTypeChange("translation")}
          disabled={disabled}
          className={`w-1/2 py-3 px-4 rounded-xl flex items-center justify-center lg:justify-start gap-2 text-sm font-inter font-medium transition ${
            disabled ? "opacity-50 cursor-not-allowed" : ""
          } ${
            type === "translation"
              ? "bg-gradient-to-r from-[#3AB1F6] to-[#407BFF] text-white"
              : "bg-[#EDF5FB] text-[#111827]"
          }`}
        >
          <ReactSVG
            src={translationIcon}
            beforeInjection={(svg) => svg.setAttribute("class", "w-4 h-auto")}
          />
          Translation
          <span className="ml-1 text-[10px] font-semibold px-1.5 py-0.5 rounded-full bg-white/20 tracking-wide">BETA</span>
        </button>
      </div>
    </div>
  );
};

export default UsagePreferenceCard;

